import { useEffect } from "react";
import "./App.css";
import { Routes, Route, useNavigate } from "react-router-dom";

import SearchNav from "./FunctionComponents/Searchnav";
import Footer from "./FunctionComponents/Footer";
import { PageLayout } from "./FunctionComponents/PageLayout";
import Home from "../src/Pages/Home";
import Metrics from "../src/Pages/Metrics";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { loginRequest } from "./authConfig";
import QueriesAnswer from "./FunctionComponents/QueriesAnswer/QueriesAnswer";
import AnalyticsPage from "./FunctionComponents/AnalyticsPage";
import HallofFamePage from "./Pages/HallofFamePage";
import Dashboard from "../src/Pages/Dashboard";

function App({ pca }) {
  return (
    <MsalWrapper pca={pca} />
  );
}

function MsalWrapper({ pca }) {
  const navigate = useNavigate();

  const navigationClient = new CustomNavigationClient({
    navigate: (path) => navigate(path),
  });

  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <Pages />
      </PageLayout>
    </MsalProvider>
  );
}

function Pages() {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
    if (activeAccount) {
      fetchAccessToken();
    }
  }, [activeAccount]);

  const fetchAccessToken = async () => {
    if (!activeAccount) return;

    try {
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });

      const bearer = `Bearer ${response.accessToken}`;
      localStorage.setItem("token", bearer);
    } catch (error) {
      console.error("Error fetching access token:", error);
      localStorage.clear();
    }
  };

  return (
    <>
      <SearchNav />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/metrics" element={<Metrics />} />
        <Route path="/queries/:id" element={<QueriesAnswer/>} />
        <Route path="/hall-of-fame" element={<HallofFamePage/>} />
        <Route path="/analytics" element={<AnalyticsPage/>} />
        <Route path="/dashboard" element={<Dashboard/>} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
